<div class="side-menu-panel">
  <div class="menu-card">

    <!-- Sección principal -->
    <div class="menu-top">

      <!-- Empresas (solo superadmin) -->
      <div
        class="item-menu"
        *ngIf="allowSuperAdmin"
        (click)="activeTab(1, 'Empresas')"
        [routerLink]="['/panel-control/list-business']"
        routerLinkActive="item-active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <i class="fal fa-table-tree pointer-in"></i>
        <p class="m-0">Empresas</p>
      </div>

      <!-- Eventos -->
      <div
        class="item-menu item-menu-events"
        (click)="activeTab(1, 'Eventos')"
        [routerLink]="['/panel-control/events']"
        routerLinkActive="item-active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <div class="item-menu-main">
          <i class="fal fa-calendar-days pointer-in"></i>
          <p class="m-0">Eventos</p>
        </div>
        <i
          *ngIf="showEventSubmenu"
          class="fal caret-icon"
          [class.fa-angle-up]="isEventSubmenuExpanded"
          [class.fa-angle-down]="!isEventSubmenuExpanded"
          (click)="toggleEventSubmenu($event)"
        ></i>
      </div>

      <app-menu-events
        class="embedded-event-menu"
        *ngIf="isEventSubmenuExpanded && eventId"
        [idEvent]="eventId"
        [draft]="isDraftEvent"
        [eventType]="eventType"
        (changeTab)="changeTab.emit($event)"
      ></app-menu-events>

      <!-- Pedidos -->
      <div
        class="item-menu"
        (click)="activeTab(2, 'Pedidos')"
        [class.item-desactive]="!admin && !allowOrder && !allowSales"
        [routerLink]="['/panel-control/orders']"
        routerLinkActive="item-active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <i class="fal fa-square-list pointer-in"></i>
        <p class="m-0">Pedidos</p>
      </div>

      <!-- Usuarios -->
      <div
        class="item-menu"
        (click)="activeTab(3, 'Usuarios')"
        [routerLink]="['/panel-control/subscribers']"
        routerLinkActive="item-active"
        [routerLinkActiveOptions]="{ exact: false }"
        [class.item-desactive]="!admin && !allowMarketing"
      >
        <i class="fal fa-user-group-simple pointer-in"></i>
        <p class="m-0">Usuarios</p>
      </div>

      <!-- Informes -->
      <div
        class="item-menu"
        (click)="activeTab(4, 'Informes')"
        [class.item-desactive]="!admin && !allowOrder && !allowSales"
        [routerLink]="['/panel-control/reports']"
        routerLinkActive="item-active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <i class="fal fa-chart-line pointer-in"></i>
        <p class="m-0">Informes</p>
      </div>

      <!-- Descuentos -->
      <div
        class="item-menu"
        (click)="activeTab(5, 'Descuentos')"
        [class.item-desactive]="!admin && !allowOrder && !allowSales"
        [routerLink]="['/panel-control/discounts']"
        routerLinkActive="item-active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <i class="fal fa-percent pointer-in"></i>
        <p class="m-0">Descuentos</p>
      </div>

      <!-- Abonos -->
      <div
        class="item-menu"
        (click)="activeTab(6, 'Abonos')"
        [class.item-desactive]="!admin && !allowSales"
        [routerLink]="['/panel-control/bonds']"
        routerLinkActive="item-active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <i class="fal fa-layer-group pointer-in"></i>
        <p class="m-0">Abonos</p>
      </div>

      <!-- Abonos de temporada (módulo season_passes) -->
      <div
        class="item-menu"
        *ngIf="showSeasonPasses"
        (click)="activeTab(6, 'Abonos de temporada')"
        [class.item-desactive]="!admin && !allowSales"
        [routerLink]="['/panel-control/sports-passes']"
        routerLinkActive="item-active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <i class="fal fa-id-card pointer-in"></i>
        <p class="m-0">Abonos de temporada</p>
      </div>

      <mat-divider class="menu-divider" *ngIf="showCashRegister"></mat-divider>

      <!-- Taquilla (módulo cash_register) -->
      <div
        class="item-menu"
        *ngIf="showCashRegister"
        (click)="openTicketOffice()"
        [class.item-desactive]="!admin && !allowSales"
      >
        <i class="fal fa-ticket pointer-in"></i>
        <p class="m-0">Taquilla</p>
      </div>

    </div>

    <!-- Sección inferior (Organización + Ayuda) -->
    <div class="menu-bottom" *ngIf="admin">

      <mat-divider class="menu-divider"></mat-divider>

      <!-- Organización con submenú desplegable -->
      <div
        class="item-menu item-menu-org"
        (click)="toggleOrgSubmenu()"
        [class.item-active]="isOrgSubmenuExpanded"
      >
        <div class="item-menu-main">
          <i class="fal fa-cog pointer-in"></i>
          <p class="m-0">Configuración</p>
        </div>
        <i class="fal caret-icon"
          [class.fa-angle-up]="isOrgSubmenuExpanded"
          [class.fa-angle-down]="!isOrgSubmenuExpanded">
        </i>
      </div>

      <ng-container *ngIf="isOrgSubmenuExpanded">
        <div class="embedded-org-menu">
          <div class="event-menu-container">

            <!-- Mi perfil -->
            <div class="item-submenu"
              [routerLink]="['/panel-control/config/info-profile']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="activeTab(5, 'Mi perfil')">
              <i class="fal fa-user"></i>
              <span>Mi perfil</span>
            </div>

            <!-- Organización -->
            <div class="item-submenu"
              [routerLink]="['/panel-control/config/business/info-business']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="activeTab(5, 'Organización')">
              <i class="fal fa-building-columns"></i>
              <span>Organización</span>
            </div>

            <!-- Gestores -->
            <div class="item-submenu"
              [routerLink]="['/panel-control/config/permission/function']"
              [queryParams]="{role: 'all'}"
              [class.active]="showPermissionSubmenu"
              (click)="activeTab(6, 'Gestores')">
              <i class="fal fa-users-gear"></i>
              <span>Gestores</span>
            </div>

            <!-- Espacios → lleva al listado -->
            <div class="item-submenu"
              [routerLink]="['/panel-control/config/venues']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="activeTab(5, 'Espacios')">
              <i class="fal fa-building"></i>
              <span>Espacios</span>
            </div>

            <!-- Submenú de espacio específico (solo cuando se está dentro de uno) -->
            <ng-container *ngIf="showVenueSubmenu && venueId">
              <div class="item-submenu item-submenu-nested"
                [routerLink]="['/panel-control/config/venues/info-venue', venueId]"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <span>Datos del espacio</span>
              </div>
              <div class="item-submenu item-submenu-nested"
                [routerLink]="['/panel-control/config/venues/tickets-venue', venueId]"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <span>Entradas base</span>
              </div>
              <div class="item-submenu item-submenu-nested" *ngIf="venueMapVersion"
                [routerLink]="['/panel-control/config/venues/map-venue', venueId]"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                [class.active]="isMapActive">
                <span>Mapa de butacas</span>
              </div>
            </ng-container>

          </div>
        </div>
      </ng-container>

      <!-- Ayuda -->
      <div
        class="item-menu"
        (click)="activeTab(7, 'Ayuda')"
        [routerLink]="['/panel-control/config/help']"
        routerLinkActive="item-active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <i class="fal fa-circle-question pointer-in"></i>
        <p class="m-0">Ayuda</p>
      </div>

    </div>
  </div>
</div>
